import styles from './page.module.css';
import TeamCard from '..//../components/TeamCard/TeamCard';
import HeroBanner from '../../components/HeroBanner/HeroBanner';
import { useState } from 'react';
import { reha, praevention, firmenfitness } from '../../../code/unsplashImages';
function MannschaftssportPage() {
    const [hasImages, setHasImages] = useState(false);
    const abteilung = [
        {
            "team": "Firmenfitness",
            "link": "/gesundheitssport/firmenfitness",
            "img": firmenfitness.path,
            "altText": firmenfitness.altText
        },
        {
            "team": "Prävention",
            "liga": "(nach §20 SGB V)",
            "link": "/gesundheitssport/praevention",
            "img": praevention.path,
            "altText": praevention.altText
        },
        {
            "team": "Rehabilitation",
            "liga": "(Reha-Sport)",
            "link": "/gesundheitssport/reha",
            "img": reha.path,
            "altText": reha.altText
        }
    ]
    return (
        <div>
            <HeroBanner category="gesundheitssport" onImagesLoaded={setHasImages} />
            <section className={styles.container} style={{ marginTop: hasImages ? '20px' : 'var(--marginTopDefault)' }} >
                <h1>Gesundheitssport</h1>

                <p>Hier gibt's alle Informationen rund um den <strong>Bereich Gesundheitssport</strong>, dessen Hauptziel es ist, die individuelle Leistungsfähigkeit zu erhalten (<strong>präventiv</strong>) oder wiederzuerlangen (<strong>rehabilitativ</strong>).<br />Wir bieten außerdem die Möglichkeit dies im Sinne der betribelichen Gesundheitsförderung (BGF) im Rahmen von Firmenfitnesskursen durchzuführen und individuelle Kursangebote gemeinsam zu gestalten.</p>
                <div className={styles.abteilungen}>
                    {abteilung.map((item, index) => (
                        <TeamCard key={index} item={item} />
                    ))}
                </div>
                <section className={styles.certSection}>
                    <h2>Unsere Zertifikate</h2>
                    <div className={styles.certLogos}>
                        <a
                            href={`${process.env.REACT_APP_BACKEND_URL}/uploads/files/urkunde_dosb_sport_pro_gesundheit.pdf`}
                            target="_blank"
                            rel="noopener noreferrer"
                        >
                            <img
                                src="/assets/icons/DOSB-Signet_SPG_2021_Farbe_rgb.png"
                                alt="DOSB Urkunde"
                            />
                        </a>

                        <a
                            href={`${process.env.REACT_APP_BACKEND_URL}/uploads/files/zertifikat_deutscher_standard_praevention.pdf`}
                            target="_blank"
                            rel="noopener noreferrer"
                        >
                            <img
                                src="/assets/icons/LOGO_DSP.png"
                                alt="Zertifikat: Deutscher Standard Prävention"
                            />
                        </a>
                    </div>

                </section>
            </section>

        </div >
    );
}

export default MannschaftssportPage;